/* Chart colors come from classes, never from SVG presentation attributes. */
.chart {
  inline-size: 100%;
  min-inline-size: 0;
}

.svg {
  display: block;
  max-inline-size: 100%;
  overflow: visible;
}

.grid {
  stroke: var(--color-border);
  stroke-width: 1;
}

.axis {
  stroke: var(--color-border-strong);
  stroke-width: 1;
}

.axisText {
  fill: var(--color-text-subtle);
  font-size: var(--text-xs);
  font-variant-numeric: var(--numeric);
}

.series {
  --series-color: var(--color-chart-1);
}

.series[data-series="2"],
.bar[data-series="2"],
.sparkline[data-series="2"] {
  --series-color: var(--color-chart-2);
}

.series[data-series="3"],
.bar[data-series="3"],
.sparkline[data-series="3"] {
  --series-color: var(--color-chart-3);
}

.series[data-series="4"],
.bar[data-series="4"],
.sparkline[data-series="4"] {
  --series-color: var(--color-chart-4);
}

.series[data-series="5"],
.bar[data-series="5"],
.sparkline[data-series="5"] {
  --series-color: var(--color-chart-5);
}

.series[data-series="6"],
.bar[data-series="6"],
.sparkline[data-series="6"] {
  --series-color: var(--color-chart-6);
}

.line {
  fill: none;
  stroke: var(--series-color, var(--color-chart-1));
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  pointer-events: none;
}

.line[data-dashed] {
  stroke-dasharray: 6 4;
}

/* A wide invisible stroke along each line, so the pointer doesn't have to land on 2px. */
.hit {
  fill: none;
  stroke: transparent;
  stroke-width: 14;
  stroke-linejoin: round;
  pointer-events: stroke;
}

.series[data-dimmed] {
  opacity: 0.2;
}

.swatch {
  flex: none;
  inline-size: var(--space-5);
  block-size: var(--space-2);
  overflow: visible;
}

.point {
  fill: var(--series-color, var(--color-chart-1));
  stroke: var(--color-surface);
  stroke-width: 1;
}

.seriesLabel {
  fill: var(--series-color, var(--color-chart-1));
  font-size: var(--text-xs);
  font-weight: var(--weight-medium);
}

/* Bar chart: HTML rows with real text, SVG bars. */
.bars {
  margin: 0;
}

.barList {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.barRow {
  display: grid;
  grid-template-columns: minmax(6rem, 30%) 1fr auto;
  gap: var(--space-3);
  align-items: center;
  font-size: var(--text-sm);
}

.barLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.barTrack {
  display: block;
  inline-size: 100%;
  block-size: var(--space-3);
}

.barBackground {
  fill: var(--color-surface-sunken);
}

.bar {
  --series-color: var(--color-chart-1);

  fill: var(--series-color);
}

.barValue {
  min-inline-size: 4ch;
  text-align: end;
  font-variant-numeric: var(--numeric);
  white-space: nowrap;
}

.sparkline {
  --series-color: var(--color-chart-1);

  display: inline-block;
  overflow: visible;
  vertical-align: middle;
}
